;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"25a95e908a12422e505d30a284817f17b390334e"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import { posthog } from "posthog-js";

import { env } from "./env";

Sentry.init({
  dsn: "https://35d541c34f3a87134429ac75e6513a16@o4503934125998080.ingest.sentry.io/4506458761396224",
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,

  replaysOnErrorSampleRate: 1.0,
  integrations: [
    posthog.sentryIntegration({
      organization: "soonlist",
      projectId: 4506458761396224,
      severityAllowList: ["error", "info"],
    }),

    Sentry.replayIntegration({}),
  ],
  enabled: env.NODE_ENV === "production",
});
